var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-box",class:'is-' + _vm.bgColor,style:(_vm.styleObject)},[_c('span',{staticClass:"text"},[_vm._v("Image")]),(_vm.path)?_c('img',{attrs:{"src":_vm.path}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }